<template>
    <ul id="list-tasks">
      <li>
        
        <div id='oblea' style='width: 630px; height:80px;'>
  
          <div id='seccion1'>
            <p id='titulo'>{{numeroPedido}}</p>   
            <div class="fv cr" style="width: 50%; height: 35px; font-size: 8px; font-weight: 500; 
                        color:#656E76; margin-left: 35px; margin-top: -7px">
                <div class="fh lb" style="height: 50%">
                    <div style="width: 84px"> Fecha de Alta:</div>
                    <div>{{item.Fecha}}</div>
                </div>
                <div class="fh lc" style="height: 50%;margin-top: -2px">
                    <div style="width: 84px"> Fecha de Entrega:</div>
                    <div>{{item.FechaEntrega}}</div>
                </div>
            </div>
            <span class='label'>Items:</span> 
            <span class='value'> {{item.CantidadItems}} </span>
            <span class='label' v-show='item.Estado!=0'>Precio Total:</span>
            <span class='value' v-show='item.Estado!=0'>{{moneyLabel}} {{montoTotalComp | formatMoney}}</span>
          </div> 
    
          <div id='seccion2'>
            <div id='seccion3'>
               <img id='iconVer' :class="{iconVerVisible:item.Estado!=0,iconVerInvisible:item.Estado==0}" src="/dist/icon-ver.png" @click='btnVerDetalle'/>
               <span id='labelVer' :class="{labelR:item.Estado!=0,labelRInvisible:item.Estado==0}" style="margin-right:10px;  margin-left:10px" @click='btnVerDetalle'> VER</span>
               <div :id="`circulo${item.Estado}`"  style="margin-left:40px"> </div>
               <span class="labelR"> {{estado(item.Estado)}} </span>
               <img id='btnEliminarBorrador' v-show='item.Estado==0'  @click="btnEliminarBorrador"  src="/dist/icon-delete.png"  style= "width:15px;height:15px;margin-left:22px">   
            </div> 
            <div id='seccion4'>
               <button id="btnIrCarrito"  v-show='item.Estado==0'  @click="btnIrCarrito">IR AL CARRITO</button>
            </div> 
          </div> 
  
        </div>




      </li>
    </ul>
  </template>
  
  
  <script>
  
    import axios from 'axios'
    import moment from 'moment' 
  
    export default {
      name: 'item-estado-pedido',
      props: ['item'],

      computed: 
      {

       montoTotalComp() 
        {
          if (this.$store.state.pedido.idMoneda == 2)
          {
            return this.item.MontoTotalDolar
          }
          else
          {
            return this.item.MontoTotal
          }
        },



        moneyLabel() 
        {
          if (this.$store.state.pedido.idMoneda == 2)
          {
            return 'U$S' 
          }
          else
          {
            return '$' 
          }
        },

        numeroPedido()
        {
          if (this.item.Numero > 0)
          {
            return 'Pedido '+this.item.Numero
          }
          else
          {
            return 'Borrador'
          }
        }
      },

      data() 
      {
         return {
           mes: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
           productos:[],
           promosVigentes:[],
           replicaPedido:[]
         }
      },
  
      methods:
      {
        
        estado(e) 
        {
          if (e==0)
          {
            return 'BORRADOR';  
          }
          else if (e==1)
          {
            return 'INGRESADO';  
          }
          else if (e==2)
          {
            return 'APROBADO ';  
          }
          else if (e==3)
          {
            return 'NO APROBADO ';  
          }
          else if (e==4)
          {
            return 'ENTREGADO PARCIAL';  
          }
          else if (e==5)
          {
            return 'ENTREGADO';  
          }
          else if (e==6)
          {
            return 'ELIMINADO';  
          }
        },
  
    
        btnVerDetalle () 
        {
          this.$store.commit('pedido/savePedidoId',this.item.Id); 
          this.$router.push({ name: 'pedidoCms' });
        },
  

        btnIrCarrito () 
        {
          if (this.$store.state.pedido.carrito.length > 0)
          {
            var obj = {
                        txt:'Existe un nuevo pedido en curso, si recupera el pedido guardado los ítems cargados en el nuevo pedido se perderán.',
                        txtBtnCancel:'Cancelar',
                        txtBtnOk:'Continuar',
                        fCancel:null,
                        fOk:this.getBorrador
                      }
            this.$store.commit('popup/open',obj);
          }
          else
          {
            this.getBorrador();
          }
        },
   
      btnEliminarBorrador() {
         var obj = {
                    txt:'¿Eliminar el borrador de pedido?',
                    txtBtnCancel:'Cancelar',
                    txtBtnOk:'Aceptar',
                    fCancel:null,
                    fOk:this.eliminarBorrador
                   }
         this.$store.commit('popup/open',obj);
       },

  
      getBorrador() {
            this.$store.commit('loader/start')
            var url = '/WebSalesPedidosListado?PedidoId='+String(this.item.Id);
            axios.get(url,{
              headers:{
                Token: this.$store.state.user.usuario.Token,
                ClientSecret: process.env.CLIENT_SECRET,
                EmpresaId: process.env.EMPRESA_ID
              }
            }).then((response) => {
              if (response.data.Code == 0)
              {
                this.$store.commit('pedido/eliminarPedido');
                this.$store.commit('pedido/setBorradorId',this.item.Id);
                this.productos = response.data.Productos
                this.getProductos(response.data.ClienteId,response.data.DepositoId)   
              }
              else 
              {
                console.log(">>>>"+response.data.Message);
                alert(response.data.Message);  
              }
            },(error) => {
              console.log(error)
              alert(error);
            })
        },
  
        getProductos (idCliente,idDeposito) {
          var url = "/WebSalesProductos?DepositoId="+idDeposito+"&ClienteId="+idCliente;
          axios
            .get(url, {
              headers: {
                Token: this.$store.state.user.usuario.Token,
                ClientSecret: process.env.CLIENT_SECRET
              }
            })
            .then(
              response => {
                this.$store.commit("loader/stop");
                if (response.data.Code == 0) 
                {
                  this.$store.commit("pedido/saveProductos",response.data.Productos);
                  var dep = this.$store.state.user.cliente.Depositos.find(elem => elem.Id === idDeposito)
                  this.$store.commit('pedido/saveDeposito',dep);
                  this.getPromociones(idCliente)
                }
                else if (response.data.Code == 99) 
                {
                  alert(response.data.Message);
                  this.$router.push({ name: "login" });
                }
                else
                {
                  console.log(">>>>" + response.data.Message);
                  alert(response.data.Message);
                }
              },
              error => {
                console.log(error);
                alert(error);
              }
            );
        },


        getPromociones(idCliente) {
            axios.get('/WebSalesPromociones?ClienteId='+idCliente,{
            headers:{        
                Token:        this.$store.state.user.usuario.Token,
                ClientSecret: process.env.CLIENT_SECRET
                }})
            .then((response) => {
                this.$store.commit("loader/stop"); 
                if (response.data.Code == 0) {
                    var promos = response.data.Promociones
                    if (promos != null) {
                        promos.forEach((j) => { 
                            var FechaInicio =  j.FechaInicio
                            var FechaFin =  j.FechaFin
                            moment.defaultFormat = "YYYY-MM-DD HH:mm:ss";
                            var fechaIniMillis = moment(FechaInicio, moment.defaultFormat).toDate().getTime()
                            var fechaFinMillis = moment(FechaFin, moment.defaultFormat).toDate().getTime() + 86399000
                            var fechaActualMillis = Date.now()
                            if ((fechaActualMillis >= fechaIniMillis) && (fechaActualMillis <= fechaFinMillis)) {
                                this.promosVigentes.push(j)
                            }
                        });    
                    }
                    this.loadBorradorCarrito()
                }
            },
            (error) => { 
                this.$store.commit("loader/stop");
            })
        },

        loadBorradorCarrito () {
          this.productos.forEach((e) => {
            if ((e.ProductoId != 0) && (e.PromocionId == 0)) {
               // es producto
                var prod = this.$store.state.pedido.productos.find(elem => elem.Id === e.ProductoId)
                if (prod != null) {
                    var nuevoProducto = {
                        id: prod.Id,
                        idCategoria:prod.CategoriaId,
                        idSubcategoria:prod.SubCategoriaId,
                        producto: prod.Nombre,
                        descripcion: prod.Nombre, 
                        precio: prod.Precio,
                        precioDeLista: prod.PrecioLista,
                        descuento: prod.Descuento,
                        precioIngresado: prod.Precio,    //ver
                        detalle: "",                     //ver
                        cantidad: e.Cantidad,
                        peso: prod.EnvasePeso,  
                        pesoMinimoPedido: prod.PesoMinimoPedido,
                        unidadesPorPedido: prod.UnidadesPorPedido,
                        archivoId:prod.ArchivoId,
                        promocionId:0,
                        tipoOblea:1,
                        esPromo:false,
                        diasEntrega:prod.DiasEntrega,
                        stockActual:prod.StockActual,
                        manejaStock:prod.ManejaStock,
                        codigo:prod.Codigo
                    }
                    this.replicaPedido.push(nuevoProducto);
                }  
            }
            else {
               // es promocion
                var promo = this.promosVigentes.find(elem => elem.Id === e.PromocionId)
                if (promo != null) {
                    var nuevaPromo = {
                        id: 0,
                        esPromo:true,
                        diasEntrega:  promo.DiasEntrega,
                        idCategoria: promo.CategoriaId,
                        idSubcategoria: promo.SubCategoriaId,
                        tieneLimiteMaximo: promo.TieneLimiteMaximo,
                        limiteMaximo: promo.LimiteMaximo,
                        producto:promo.Nombre,
                        descripcion:promo.Nombre,
                        precioIngresado:promo.PrecioPromocional,
                        cantidad: e.Cantidad,
                        peso:promo.Peso,
                        archivoId:promo.ArchivoId,
                        promocionId:promo.Id,
                        tipoOblea:1
                    }
                    this.replicaPedido.push(nuevaPromo);
                }
            }
            console.log(this.replicaPedido)
          })
          this.$store.commit('loader/stop')
          this.$store.commit('pedido/replicarPedido',this.replicaPedido);
          this.$router.push({name: 'pedido'});
        },

        eliminarBorrador () {
          this.$store.commit('loader/start')
          var bdParam = { BorradorId: this.item.Id,
                          ClienteId:this.$store.state.user.cliente.Id,	
                          EmpleadoId:this.$store.state.user.usuario.EmpleadoId
                        }
  
          axios.put('/WebSalesBorrador',bdParam,{
           headers:{
                      Token: this.$store.state.user.usuario.Token,
                      ClientSecret: process.env.CLIENT_SECRET
                  }
           }
          ).then((response) => {
           this.$store.commit('loader/stop')
           if (response.data.Code == 0)
           {
            this.$emit('borradorEliminado');
           }
           else if (response.data.Code == 99)
           {
             alert(response.data.Message);
           }
           else
           {
             alert(">>>>"+response.data.Message);
             console.log(">>>>"+response.data.Message);
           }
        },(error) => { console.log(error) 
            alert(error);  })
    
        },
    
        getFecha (millis) {
         var sFecha='';
         var date = new Date(millis);
         sFecha = date.getDate();
         sFecha = sFecha + ' ' + this.mes[date.getMonth()];
         sFecha = sFecha + ' ' + date.getFullYear();
         sFecha = sFecha + ' - ' + date.getHours();
         sFecha = sFecha + ':' + date.getMinutes() + 'hs';
         return sFecha;  
        }
  
      }
    
    }
  </script>
  
  
  <style scoped>
    
  * {
    margin:  0;
    padding: 0;
  }
    
  .texto{
  color: #717A82;
  }
   
  
  #btnIrCarrito{
    width: 105px;
    height: 25px;
    margin-right: 10px;
    font-size: 9px;
    border-style: solid;
    border:none; 
    background: #44C7F4; 
    border-radius: 20px;  
    color: #ffffff;
    outline: none;
  }
  
  
  #btnIrCarrito:hover{
      cursor: pointer;
    }    
   
  
  
  .labelR {
    font-size: 11px; 
    vertical-align: middle;
  }
  

  .labelRInvisible {
    font-size: 11px; 
    vertical-align: middle;
    opacity: 0;
  }
  
  
  .iconVerVisible {
    width:15px;
    height:15px;
  }
  
  
  .iconVerInvisible {
    width:15px; 
    height:15px;
    opacity:0;
  }
  

  /* BORRADOR = 0,
  INGRESADO = 1,
  APROBADO = 2,
  NO_APROBADO = 3,
  ENTREGADO_PARCIAL = 4,
  ENTREGADO = 5,
  ELIMINADO = 6 */


  /*borrador*/
  #circulo0 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #D0D2D3;  
    margin: 10px;
  }


  /*ingresado*/
  #circulo1 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #FFC107;  
    margin: 10px;
  }


  /*aprobado*/
  #circulo2 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #4CD964;  
    margin: 10px;
  }


  /*no aprobado*/
  #circulo3 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: red;  
    margin: 10px;
  }


    
  /*entregado parcial */
  #circulo4 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #FF51D9;  
    margin: 10px;
   }
  

  /*entregado*/
  #circulo5 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #5B84FF;  
    margin: 10px;
   }
  

  /*eliminado */
  #circulo6 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #666666;  
    margin: 10px;
   }


  #oblea {
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    display: flex;
    align-items: flex-start; 
  }
  
  
  #seccion1{
    width: 64%;
    height:100%;
    background: #ffffff;  
  }
  

  #seccion2{
      width: 36%;
      height:100%;
      background: #ffffff;  
      display: flex;            
      flex-direction: column;  
      justify-content: center;  
      align-items: flex-start;  
    }
    
    
    
    #seccion3 {
      width: 100%;
      height:30px;
      background: #ffffff;  
      display: flex;            
      flex-direction: row;  
      justify-content: flex-start;  
      align-items: center;  
      margin-top: 0px;
    }
    
    
    
    #seccion4 {
      width: 100%;
      height:30px;
      background: #ffffff;  
      display: flex;            
      justify-content: flex-end;  
      align-items: center;  
      margin-top: 5px;
    }
 
  
  
  #titulo{
    font-size: 16px;
    color: #656E76;
    margin-top: 12px;
    margin-left: 35px;
    font-weight: 500;
  }
  
  #fecha{
    font-size: 10px;
    color: #656E76;
    margin-top: 3px;
    margin-left: 35px;
    margin-bottom: 10px;
  }
  
  .label{
    font-size: 12px;
    font-weight: 500;
    color: #656E76;
    margin-top: 10px;
    margin-left: 35px;
  }
  
  .value{
    font-size: 12px;
    color: #656E76;
    margin-top: 10px;
  
  }
  
  .ver-enviado{
    font-size: 12px;
    color: #656E76;
    vertical-align: middle;
    margin-top: 25px;
    margin-left: 35px;
  } 
  
  .icon{
    width: 10px;
    height: 10px;
    vertical-align: middle;
  }
  
  
  #iconVer:hover { cursor: pointer; }
  #labelVer:hover { cursor: pointer; }
  #btnEliminarBorrador:hover { cursor: pointer; }
  
  
  
  
   </style>


// WEBPACK FOOTER //
// src/components/views/estadoPedido/itemEstadoPedido.vue